export default "__VITE_ASSET__CAjJiIaA__"